import { X, Check, MessageCircle } from "lucide-react";
import { Reveal } from "./shared";
import { WHATSAPP_URL } from "@/lib/api";

const NEVER = [
  "Não acenda fósforos ou isqueiros",
  "Não acione interruptores ou aparelhos elétricos",
  "Não procure vazamento com fogo",
  "Não ignore o cheiro de gás",
];

const DO = [
  "Feche o registro de gás",
  "Abra portas e janelas",
  "Saia do ambiente",
  "Chame um especialista imediatamente",
];

export const Safety = () => (
  <section className="bg-white py-24 sm:py-32" data-testid="safety-section">
    <div className="mx-auto grid max-w-6xl gap-6 px-5 lg:grid-cols-2 lg:px-8">
      <Reveal>
        <div className="h-full rounded-3xl border border-red-200 bg-red-50 p-9" data-testid="safety-never-panel">
          <h3 className="font-display text-3xl font-bold uppercase italic text-red-600">Nunca faça isso!</h3>
          <ul className="mt-7 space-y-5">
            {NEVER.map((item, i) => (
              <li key={i} className="flex items-center gap-4" data-testid={`safety-never-${i}`}>
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-red-600">
                  <X size={18} strokeWidth={3} className="text-white" />
                </span>
                <span className="font-medium text-red-900">{item}</span>
              </li>
            ))}
          </ul>
        </div>
      </Reveal>
      <Reveal delay={0.12}>
        <div className="h-full rounded-3xl border border-emerald-200 bg-emerald-50 p-9" data-testid="safety-do-panel">
          <h3 className="font-display text-3xl font-bold uppercase italic text-emerald-600">Faça isso!</h3>
          <ul className="mt-7 space-y-5">
            {DO.map((item, i) => (
              <li key={i} className="flex items-center gap-4" data-testid={`safety-do-${i}`}>
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-emerald-600">
                  <Check size={18} strokeWidth={3} className="text-white" />
                </span>
                <span className="font-medium text-emerald-900">{item}</span>
              </li>
            ))}
          </ul>
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noreferrer"
            data-testid="safety-whatsapp-button"
            className="mt-8 inline-flex items-center gap-2 rounded-full bg-[var(--whatsapp)] px-6 py-3 font-display text-sm font-bold uppercase tracking-wider text-black transition-transform duration-300 hover:scale-105"
          >
            <MessageCircle size={16} strokeWidth={2.5} />
            Falar com especialista agora
          </a>
        </div>
      </Reveal>
    </div>
  </section>
);
